import { Cancel, Save } from '@mui/icons-material';
import {
  Card,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import CustomButton from '../../../Common/Components/Controls/InputControls';
import { Loader } from '../../../Common/Components/Loader';
import {
  CardWrapper,
  FooterContainer,
  FooterWrapper,
  PaperWrapper,
} from '../Common/CommonComponents';
import {
  CustomerModuleMetaData,
  Customermodulevariable,
  ModuleVariable,
  ModuleVariablesWrapper,
} from './Model/ModulesModel';
import { moduleService } from './ModuleService';
import { showToast } from '../../../lib/toast';

interface Param {
  customerId: string;
}

const ModulesHomePage = () => {
  const params = useParams<Param>();
  const history = useHistory();
  const [customermodulemetadata, setCustomerModuleMetaData] =
    useState<CustomerModuleMetaData>();
  const [loading, setLoading] = useState(true);
  const initialModuleVariableWrapperList: ModuleVariablesWrapper[] = [];
  const [moduleVariablesWrapperList, setModuleVariablesWrapperList] =
    React.useState(initialModuleVariableWrapperList);

  const loadRegisterTenant = async () => {
    await moduleService.GetCustomerModules(params.customerId).then((data) => {
      setCustomerModuleMetaData(data);
      if (data) {
        data.AvailableModules.map((am) =>
          am.Checked ? GetModuleVariables(am.Value, params.customerId) : null,
        );
      }
      setLoading(false);
    });
  };

  const GetModuleVariables = async (module: string, customerId: string) => {
    setLoading(true);
    await moduleService.GetModuleVariables(module, customerId).then((data) => {
      const modulevariableswrapper = {} as ModuleVariablesWrapper;
      modulevariableswrapper.ModuleId = module;
      modulevariableswrapper.ModuleVariables = data;
      setModuleVariablesWrapperList((prevlist) => [
        ...prevlist.filter((item) => item.ModuleId !== module),
        modulevariableswrapper,
      ]);
    });
    setLoading(false);
  };

  const getsubText = (downtimeScope: string) => {
    if (downtimeScope === 'None') {
      return '(can be installed immediately)';
    } else if (downtimeScope === 'Tenant') {
      return '(can be installed immediately with downtime)';
    }
  };

  const updateModuleVariable = async (
    event: React.ChangeEvent<HTMLInputElement>,
    mv: ModuleVariable,
  ) => {
    const newValue = event.target.value;
    setModuleVariablesWrapperList((prevList) =>
      prevList.map((wrapper) => {
        if (wrapper.ModuleId === mv.ModuleID) {
          return {
            ...wrapper,
            ModuleVariables: wrapper.ModuleVariables.map((variable) =>
              variable.VariableName === mv.VariableName
                ? { ...variable, Value: newValue }
                : variable,
            ),
          };
        } else {
          return wrapper;
        }
      }),
    );
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const customermodulevariables: Customermodulevariable[] = [];
      moduleVariablesWrapperList.forEach((element) => {
        element.ModuleVariables.forEach((mv) => {
          const modulevariable: Customermodulevariable = {
            ModuleID: mv.ModuleID,
            CustomerID: params.customerId,
            VariableName: mv.VariableName,
            Value: mv.Value,
          };
          customermodulevariables.push(modulevariable);
        });
      });

      await moduleService.SaveModulesForCustomer(
        params.customerId,
        customermodulevariables,
      );
      showToast({
        title: 'Modules Saved Successfully',
        type: 'success',
      });
    } catch (error) {
      showToast({
        type: 'error',
        title: `Error saving modules:${error}`,
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = async () => {
    history.push('/customer');
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;

    setLoading(true);
    setCustomerModuleMetaData((prevState) => {
      if (!prevState) {
        prevState = {
          CustomerSubdomain: '',
          CustomerID: '',
          SelectedModules: [],
          AvailableModules: [],
        };
      }

      const index = prevState.AvailableModules.findIndex(
        (module) => module.Text === name,
      );
      const module = prevState.AvailableModules[index].Value;
      if (checked) {
        GetModuleVariables(module, params.customerId);
      } else {
        const latestmoduleVariablesWrapperList =
          moduleVariablesWrapperList.filter((mvwl) => mvwl.ModuleId !== module);
        setModuleVariablesWrapperList(latestmoduleVariablesWrapperList);
      }

      if (index !== -1) {
        const newAvailableModules = [...prevState.AvailableModules];
        newAvailableModules[index] = {
          ...newAvailableModules[index],
          Checked: checked,
        };

        return { ...prevState, AvailableModules: newAvailableModules };
      }
      return prevState;
    });
    setLoading(false);
  };

  useEffect(() => {
    loadRegisterTenant().catch((err) => console.log(err));
  }, []);
  return (
    <div>
      {loading ? (
        <Loader loading={loading} />
      ) : (
        <PaperWrapper>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Register Modules for Customer :{' '}
            {customermodulemetadata?.CustomerSubdomain}
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <CardWrapper>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                  modules/Repos
                </Typography>
                <Divider sx={{ mb: 3 }} />
                <FormGroup>
                  {customermodulemetadata?.AvailableModules.map(
                    (availableModule) => (
                      <FormControlLabel
                        key={availableModule.Text}
                        control={
                          <Checkbox
                            checked={availableModule.Checked}
                            name={availableModule.Text}
                            onChange={handleChange}
                          />
                        }
                        label={
                          availableModule.Text +
                          ' ' +
                          getsubText(
                            availableModule.UnderlyingObject.DowntimeScope,
                          )
                        }
                      />
                    ),
                  )}
                </FormGroup>
              </CardWrapper>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <CardWrapper>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                  Configure Rno/Repo Name
                </Typography>
                <Divider sx={{ mb: 3 }} />
                {moduleVariablesWrapperList.length > 0 ? (
                  <FormGroup>
                    {moduleVariablesWrapperList.map(
                      (moduleVariablesWrapper) => (
                        <Card
                          key={moduleVariablesWrapper.ModuleId}
                          elevation={2}
                          sx={{
                            p: 2,
                            m: 1,
                            display: 'flex',
                            flexDirection: 'column', // Stack items on mobile
                            alignItems: 'flex-start', // Align text properly
                          }}
                        >
                          <Typography variant="h6" sx={{ width: '100%' }}>
                            {moduleVariablesWrapper.ModuleId}
                          </Typography>

                          <Grid container spacing={2} sx={{ mt: 1 }}>
                            {moduleVariablesWrapper.ModuleVariables.map(
                              (mv) => (
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  key={mv.ModuleID}
                                >
                                  <Card
                                    sx={{
                                      p: 2,
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <Typography textAlign="center">
                                      {mv.DisplayName}
                                    </Typography>
                                    <TextField
                                      id={mv.VariableName}
                                      fullWidth // Ensures responsiveness
                                      value={mv.Value}
                                      onChange={(e) =>
                                        updateModuleVariable(
                                          e as React.ChangeEvent<HTMLInputElement>,
                                          mv,
                                        )
                                      }
                                    />
                                  </Card>
                                </Grid>
                              ),
                            )}
                          </Grid>
                        </Card>
                      ),
                    )}
                  </FormGroup>
                ) : (
                  <Typography>No Module Variables for Customer</Typography>
                )}
              </CardWrapper>
            </Grid>
          </Grid>
          <FooterWrapper>
            <FooterContainer>
              <Grid item xs={12} sm="auto">
                <CustomButton
                  startIcon={<Save />}
                  variant="contained"
                  onClick={handleSave}
                  label="Save"
                />
              </Grid>
              <Grid item xs={12} sm="auto">
                <CustomButton
                  startIcon={<Cancel />}
                  variant="contained"
                  onClick={handleCancel}
                  label="Cancel"
                ></CustomButton>
              </Grid>
            </FooterContainer>
          </FooterWrapper>
        </PaperWrapper>
      )}
    </div>
  );
};

export default ModulesHomePage;
